import JsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DISCLAIMER, DISCLAIMER_CONTENT, WEBSITE_URL } from '../constants/PDFConstants';

const marginLeft = 20;
const marginRight = 20;
const marginTop = 10;
const marginBottom = 10;

let pdf: JsPDF;
let pages: HTMLElement[] = [];
let pagesReady = 0;

const initPdf = (numberOfPages: number) => {
    if (numberOfPages === 0) {
        return;
    }
    pdf = new JsPDF({
        orientation: 'l',
        unit: 'mm',
        format: 'letter',
    });
    pages = Array<HTMLElement>(numberOfPages);
    pagesReady = 0;
};

const addPage = (page: HTMLElement, index: number) => {
    if (index < pages.length && pages[index] === undefined) {
        pages[index] = page;
        pagesReady = pagesReady + 1;
    }
};

const isDocumentReady = () => {
    return pagesReady > 0 && pages.length > 0 && pagesReady === pages.length;
};

const generatePdf = async (filename: string) => {
    let firstPageAdded = false;
    let index = 0;
    console.time('generatePdf');

    const staticDisplayWidth = 255;

    for (const page of pages) {
        index = index + 1;
        console.log('generating pdf page ', index);
        const canvas = await html2canvas(page, { scale: 3 }); //scale for increasing the quality of text/images

        const imgData = canvas.toDataURL('image/png');
        const pageWidth = 295.4;
        const pageHeight = 215.9;
        const footerAreaHeight = 20;

        if (!firstPageAdded) {
            pdf.internal.pageSize.width = pageWidth;
            pdf.internal.pageSize.height = pageHeight;
            firstPageAdded = true;
        } else {
            pdf.addPage([pageWidth, pageHeight]);
        }

        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const aspectRatio = imgWidth / imgHeight;

        let displayHeight = staticDisplayWidth / aspectRatio;

        // Ensure the display height fits within the page constraints
        if (displayHeight > pageHeight - marginTop - marginBottom - footerAreaHeight) {
            displayHeight = pageHeight - marginTop - marginBottom - footerAreaHeight;
        }

        pdf.addImage(imgData, 'PNG', marginLeft, marginTop, staticDisplayWidth, displayHeight);
        if (isLastPage(index, pages.length)) {
            addDisclaimer(pdf, pageWidth, pageHeight);
        }
        addPaginationText(pdf, index, pageWidth, pageHeight);
    }

    console.log('saving pdf: ', filename);
    pdf.save(filename);
    console.timeEnd('generatePdf');
};

const addPaginationText = (pdf: JsPDF, index: number, pageWidth: number, pageHeight: number) => {
    pdf.setFontSize(5);
    pdf.setFont('helvetica', 'normal');
    pdf.setLineHeightFactor(1.5);
    pdf.setTextColor(0);
    pdf.setDrawColor(0);
    pdf.setLineWidth(0.5);
    pdf.text(
        `Page ${index} of ${pages.length}`,
        pageWidth - marginRight,
        pageHeight - marginBottom - 10,
        { align: 'right' },
    );
    pdf.text(WEBSITE_URL, marginLeft, pageHeight - marginBottom - 10);
};

const addDisclaimer = (pdf: JsPDF, pageWidth: number, pageHeight: number) => {
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(0);
    pdf.text(DISCLAIMER, marginLeft, pageHeight - marginBottom - 23);

    pdf.setFontSize(5);
    pdf.setFont('helvetica', 'normal');
    pdf.setLineHeightFactor(1.2);
    pdf.setTextColor(0);
    pdf.text(DISCLAIMER_CONTENT, marginLeft, pageHeight - marginBottom - 20, {
        maxWidth: pageWidth - marginLeft - marginRight,
    });
};

const isLastPage = (index: number, totalPages: number) => {
    return index === totalPages;
};

export { initPdf, addPage, isDocumentReady, generatePdf };
